export function fullscreen(elem, isFullscreen) {
  if (isFullscreen) {
    if( elem.requestFullscreen ) {
      elem.requestFullscreen();
      return true;
    } else if( elem.mozRequestFullScreen ) {
      elem.mozRequestFullScreen();
      return true;
    } else if( elem.webkitRequestFullscreen ) {
      elem.webkitRequestFullscreen();
      return true;
    } else if( elem.msRequestFullscreen ) {
      elem.msRequestFullscreen();
      return true;
    } else {
      return false;
    }
  } else {
    if( document.exitFullscreen ) {
      document.exitFullscreen();
      return true;
    } else if( document.mozCancelFullScreen ) {
      document.mozCancelFullScreen();
      return true;
    } else if( document.webkitCancelFullScreen ) {
      document.webkitCancelFullScreen();
      return true;
    } else if( document.msExitFullscreen ) {
      document.msExitFullscreen();
      return true;
    } else {
      return false;
    }
  }
}
  